var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOval3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.5%",
    y: "-18.2%",
    width: "145.5%",
    height: "145.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Organisations/DetailEdited",
    transform: "translate(-420.000000, -535.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Informations",
    transform: "translate(1.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2",
    transform: "translate(13.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#019ED3",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9043008,21.7567906 C21.7847143,21.8734465 21.7175262,22.0317022 21.7175262,22.1967213 C21.7175262,22.3617404 21.7847143,22.5199961 21.9043008,22.636652 L24.6605557,25.3267569 C24.9095921,25.5691832 25.3127532,25.5689266 25.5614655,25.3261835 C25.8101777,25.0834403 25.8104406,24.6899551 25.562053,24.4468955 L23.8942024,22.8189435 L29.5591986,22.8189435 C29.9112927,22.8189435 30.1967213,22.5403652 30.1967213,22.1967213 C30.1967213,21.8530775 29.9112927,21.5744991 29.5591986,21.5744991 L23.8942024,21.5744991 L25.562053,19.9465471 C25.8104406,19.7034875 25.8101777,19.3100023 25.5614655,19.0672591 C25.3127532,18.824516 24.9095921,18.8242594 24.6605557,19.0666858 L21.9043008,21.7567906 Z M14.4408014,30.1967213 L23.6393439,30.1967213 C23.991418,30.1967213 24.2768667,29.9181234 24.2768667,29.5744991 L24.2768667,26.5088742 C24.2768667,26.1652304 23.991438,25.886652 23.6393439,25.886652 C23.2872499,25.886652 23.0018212,26.1652304 23.0018212,26.5088742 L23.0018212,28.9522769 L15.0783242,28.9522769 L15.0783242,15.4411658 L23.0018212,15.4411658 L23.0018212,17.8845684 C23.0018212,18.2282123 23.2872499,18.5067906 23.6393439,18.5067906 C23.991438,18.5067906 24.2768667,18.2282123 24.2768667,17.8845684 L24.2768667,14.8189435 C24.2768667,14.4753192 23.991418,14.1967213 23.6393439,14.1967213 L14.4408014,14.1967213 C14.0887273,14.1967213 13.8032787,14.4753192 13.8032787,14.8189435 L13.8032787,29.5744991 C13.8032787,29.9181234 14.0887273,30.1967213 14.4408014,30.1967213 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(22.000000, 22.196721) rotate(-90.000000) translate(-22.000000, -22.196721) "
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval3);
export default __webpack_public_path__ + "static/media/Oval 3.2dcb76a32946069548950053253d893d.svg";
export { ForwardRef as ReactComponent };